import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';

import { useCallback, useState } from 'react';

export interface ProcessingResult {
	message?: string;
	success: boolean;
}

export interface ProcessingState {
	isProcessing: boolean;
	result?: ProcessingResult;
}

export interface UseProcessingResult {
	reset: () => void;
	start: () => void;
	state: ProcessingState;
	stop: (result?: ProcessingResult) => void;
}

const defaultState: ProcessingState = {
	isProcessing: false
};

export const genericProcessingFailure: ProcessingResult = {
	message: COPY_GENERIC.CONTACT_SUPPORT,
	success: false
};

export function useProcessing(): UseProcessingResult {
	const [ state, setState ] = useState(defaultState);

	const reset = useCallback(() => {
		setState(defaultState);
	}, []);

	const start = useCallback(() => {
		setState({ isProcessing: true });
	}, []);

	const stop = useCallback((result?: ProcessingResult) => {
		setState({
			isProcessing: false,
			result
		});
	}, []);

	return {
		reset,
		start,
		state,
		stop
	};
}
